import { Ticket, PlayCircle, MapPin, CalendarDays } from "lucide-react";

const GOLD = "#C9A84C";
const POSTER = "https://customer-assets.emergentagent.com/job_deshflix-preview/artifacts/hzpzc4va_WhatsApp%20Image%202026-05-29%20at%2021.11.34.jpeg";

export function EventBanner() {
  return (
    <article
      data-testid="event-banner-sakib"
      className="relative h-full w-full overflow-hidden rounded-2xl border animate-fade-up"
      style={{ borderColor: "rgba(201,168,76,0.32)" }}
    >
      {/* Poster background */}
      <img
        src={POSTER}
        alt="Sakib Al Hasan — The Legend"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />

      {/* Cinematic overlays */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(10,10,15,0.25) 0%, rgba(10,10,15,0.55) 45%, rgba(10,10,15,0.95) 100%)",
        }}
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(120% 60% at 50% 100%, rgba(201,168,76,0.18) 0%, rgba(10,10,15,0) 55%)",
        }}
      />

      {/* Top row: LensStory presents + LIVE EVENT */}
      <div className="absolute top-3 left-3 right-3 flex items-start justify-between gap-2 z-10">
        <span
          className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-[10px] font-bold tracking-[0.18em] uppercase backdrop-blur-md"
          style={{
            color: GOLD,
            backgroundColor: "rgba(10,10,15,0.65)",
            border: `1px solid ${GOLD}66`,
          }}
        >
          <Ticket size={11} /> LensStory Presents
        </span>

        <span
          className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-[10px] font-extrabold tracking-[0.22em] uppercase"
          style={{
            color: "#0a0a0f",
            background: `linear-gradient(135deg, ${GOLD} 0%, #e7c266 100%)`,
            boxShadow: "0 0 18px rgba(201,168,76,0.55)",
          }}
        >
          <span
            className="relative flex h-1.5 w-1.5"
            aria-hidden="true"
          >
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-500 opacity-80" />
            <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-red-500" />
          </span>
          Live Event
        </span>
      </div>

      {/* Bottom content */}
      <div className="absolute bottom-0 left-0 right-0 p-4 z-10 flex flex-col gap-3">
        <div>
          <h2
            className="font-heading text-3xl sm:text-4xl font-extrabold leading-[0.95] tracking-tight"
            style={{
              backgroundImage: `linear-gradient(180deg, #fff 0%, ${GOLD} 100%)`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            Sakib Al Hasan
          </h2>
          <p
            className="font-heading text-xs font-bold tracking-[0.32em] uppercase mt-0.5"
            style={{ color: GOLD }}
          >
            — The Legend —
          </p>
          <p className="text-white/85 text-xs sm:text-sm mt-1.5 font-medium">
            One Legend. <span style={{ color: GOLD }}>Two Nights.</span> Unforgettable Memories.
          </p>
        </div>

        {/* Event details */}
        <div
          className="grid grid-cols-2 gap-2 rounded-xl p-2.5 backdrop-blur-md"
          style={{
            backgroundColor: "rgba(10,10,15,0.55)",
            border: `1px solid ${GOLD}33`,
          }}
        >
          <EventCol day="Saturday" date="4 Jul" city="Sydney" />
          <EventCol day="Sunday" date="5 Jul" city="Melbourne" />
        </div>

        <p
          className="text-center text-[10px] font-bold tracking-[0.3em] uppercase -mt-0.5"
          style={{ color: GOLD }}
        >
          Live & Exclusive
        </p>

        {/* CTAs */}
        <div className="flex gap-2">
          <a
            href="#"
            data-testid="event-get-tickets"
            className="flex-1 inline-flex items-center justify-center gap-1.5 font-semibold text-[13px] py-2.5 rounded-xl transition active:scale-[0.98]"
            style={{
              color: "#0a0a0f",
              background: `linear-gradient(135deg, ${GOLD} 0%, #e7c266 100%)`,
              boxShadow: "0 6px 24px rgba(201,168,76,0.35)",
            }}
          >
            <Ticket size={15} /> Get Tickets
          </a>
          <a
            href="#"
            data-testid="event-watch-highlights"
            className="flex-1 inline-flex items-center justify-center gap-1.5 font-semibold text-[13px] py-2.5 rounded-xl border bg-bg/40 backdrop-blur-md text-white hover:bg-white/5 transition active:scale-[0.98]"
            style={{ borderColor: `${GOLD}66` }}
          >
            <PlayCircle size={15} /> Watch Highlights
          </a>
        </div>
      </div>
    </article>
  );
}

function EventCol({ day, date, city }) {
  return (
    <div className="text-white">
      <p
        className="text-[9px] font-bold tracking-[0.22em] uppercase"
        style={{ color: GOLD }}
      >
        {day}
      </p>
      <p className="font-heading text-base font-extrabold leading-tight inline-flex items-center gap-1">
        <CalendarDays size={13} style={{ color: GOLD }} /> {date}
      </p>
      <p className="text-[11px] text-white/85 inline-flex items-center gap-1 mt-0.5">
        <MapPin size={11} style={{ color: GOLD }} /> {city}
      </p>
    </div>
  );
}
